// 9fbef606107a605d69c0edbcd8029e5d

export const OUTFIT_LABELS = 'OutfitLabels.Outfit_Sub';

export const outfitLabels = {
  OutfitLabels: {
    Outfit_Sub: {
      lbl_outfit_viewdetail: 'View Product Details',
      lbl_outfit_unavailable: 'item(s) in this outfit are currently unavailable',
    },
  },
};
